<template>
  <v-navigation-drawer
    app
    width="260"
    id="app-drawer"
    v-model="drawer"
    enable-resize-watcher
    floating
    mini-variant-width="80"
    class="vuse-sidebar"
    :mini-variant="isMinSideNav"
    :expand-on-hover="isMinSideNav"
    :left="!isSidenavPostionRight"
    :right="isSidenavPostionRight"
    :clipped="isClippedOver"
    :dark="semidark"
    :class="!semidark ? 'neu-glow' : ''"
  >
    <!-- App Logo -->
    <v-list-item
      v-if="!isClippedOver"
      :class="{
        'logo-section': true,
        'semi-dark': semidark,
        'text-center': true,
      }"
      @click="goToDashboard()"
    >

    <v-list-item-avatar tile v-show="isMinSideNav">
        <div class="text-h6 primary--text">A</div>
        <span class="primary--text">pex</span>
      </v-list-item-avatar>
      <v-list-item-content>
        <div class="pl-5 pr-5">
        <img src="/static/assets/apex.png" height="45" />
        </div>
      </v-list-item-content>
    </v-list-item>
    <v-sheet color="transparent" :height="!isClippedOver ? 90 : 15" />
    <v-list
      dense
      v-bind="{ ...activeItemStyle }"
      expand="expand"
      class="nav-drawer transparent"
      id="app-sidebar"
    >
      <template v-for="(item, i) in items">
        <!-- 1 -->
        <ListGroup v-bind="item" :key="i" v-if="item.items" />
        <v-subheader
          v-else-if="item.header"
          class="heading-text ml-2 nav-subheader"
          :key="`${i}-item`"
          :class="{ 'mt-3': i !== 0 }"
        >
          <v-icon>more_horiz</v-icon>
          <span>
            {{ item.header }}
          </span>
        </v-subheader>
        <!-- <div v-else v-bind="item" :key="`si-${i}`">{{showMe(item)}}</div> -->
        <NavigationItem
          v-else
          :key="`si-${i}`"
          v-bind="item"
          v-show="showMe(item)"
        />
      </template>
      <v-spacer class="mb-5"></v-spacer>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import appDrawerItems from "@/config/navigation-items";
import ListGroup from "@/components/UI/NavigationItems/ListGroup";
import NavigationItem from "@/components/UI/NavigationItems/NavigationItem";
import _ from "lodash";

export default {
  data() {
    return {
      items: appDrawerItems,
    };
  },
  methods: {
    goToDashboard() {
      this.$router.push("/dashboard");
    },
    showMe(item) {
      const allow1 = item.adminOnly && this.isAdmin;
      if (allow1) {
        return allow1 && this.isSubscriptionActive;
      }
      const allow2 =
        _.get(item, "permissions") &&
        this.hasAccess(_.get(item, "permissions"));
      return allow2 && this.isSubscriptionActive;
    },
  },
  computed: {
    ...mapState({
      isAdmin: (state) => state.account.data.isAdmin,
      isSubscriptionActive: (state) => {
        return state.account.data.subscriptionStatus === "Active";
      },
    }),
    activeItemStyle: (state) => state.activeMenuStyle,
    ...mapGetters("navigations", [
      "isVisibleSideNav",
      "isMinSideNav",
      "activeItemStyle",
      "isSidenavPostionRight",
      "isClippedOver",
    ]),
    ...mapGetters("scheme", ["semidark"]),
    ...mapGetters("account", ["hasAccess"]),
    activemenu() {
      return this.$vuetify.theme.activemenu;
    },
    drawer: {
      get() {
        return this.isVisibleSideNav;
      },
      set(value) {
        this.$store.dispatch("navigations/setSidenavVisibility", value);
      },
    },
  },
  components: {
    ListGroup,
    NavigationItem,
  },
};
</script>
